import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { styled } from '@mui/material/styles';

const steps = [
  'Onboard Product',
  'Onboard Data Asset',
  'Data Profiling',
  'Data Quality',
  'Publish',
];

const GreenStepper = styled(Stepper)({
  '& .MuiStepConnector-line': {
    // borderColor: '#22c55e', // green-500
  },
  '& .MuiStepIcon-root': {
    // color: '#22c55e', // green-500
    fontSize: '2rem', // Increase icon size
    width: '2rem',
    height: '2rem',
    '&.Mui-active': {
      color: '#A6DB00', // green-600
    },
    '&.Mui-completed': {
      color: '#A6DB00', // green-600
    }
  },
  '& .MuiStepLabel-label': {
    fontSize: '1rem', // Increase label font size
    fontWeight: '500',
    marginTop: '8px'
  }
});

export default function StepperComponent({step}) {
  return (
    <Box sx={{ width: '90%', margin: 'auto', display: 'block', padding: '15px 0px 20px 0px' }}>
      <GreenStepper activeStep={step} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </GreenStepper>
    </Box>
  );
}
